/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessCodeModel } from '../../models/access-code-model';

export interface SessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGet$Params {
  systemIdentifierId: string;
  accessCode: string;
}

export function sessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGet(http: HttpClient, rootUrl: string, params: SessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<AccessCodeModel>> {
  const rb = new RequestBuilder(rootUrl, sessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGet.PATH, 'get');
  if (params) {
    rb.path('systemIdentifierId', params.systemIdentifierId, {});
    rb.path('accessCode', params.accessCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<AccessCodeModel>;
    })
  );
}

sessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGet.PATH = '/Session/AccessCodeConfigGet/{systemIdentifierId}/{accessCode}';
